<script setup>
import { computed } from 'vue';
import Button from 'next/button/Button.vue';
import { DEFAULT_ACCENT_COLOR } from 'dashboard/composables/useAccentColor';

const props = defineProps({
  value: {
    type: String,
    default: DEFAULT_ACCENT_COLOR,
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  resetLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const selectedColor = computed(() => props.value || DEFAULT_ACCENT_COLOR);

const updateColor = event => emit('change', event.target.value);
const resetColor = () => emit('change', DEFAULT_ACCENT_COLOR);
</script>

<template>
  <div class="flex w-full items-start justify-between gap-4">
    <div>
      <label
        for="agent-accent-color"
        class="text-sm font-medium text-n-gray-12"
      >
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
    <div class="flex flex-shrink-0 items-center gap-2">
      <label
        for="agent-accent-color"
        class="flex h-9 cursor-pointer items-center gap-2 rounded-lg px-2 outline outline-1 outline-n-weak hover:outline-n-slate-6"
      >
        <input
          id="agent-accent-color"
          type="color"
          :value="selectedColor"
          class="h-6 w-7 cursor-pointer border-0 bg-transparent p-0"
          @change="updateColor"
        />
        <span class="min-w-16 font-mono text-xs text-n-slate-11">
          {{ selectedColor }}
        </span>
      </label>
      <Button
        sm
        slate
        faded
        icon="i-lucide-rotate-ccw"
        :label="resetLabel"
        @click="resetColor"
      />
    </div>
  </div>
</template>
